/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Grid } from '@mui/material';
import validate from 'validate.js';
import moment from 'moment';
import * as selectorsControleFrequencias from '../../../store/controleFrequencia/reducer';
import * as actionsControleFrequencias from '../../../store/controleFrequencia/actions';
import * as selectorsAuth from '../../../store/auth/reducer';
import * as Role from '../../../constants/role';
import {
  DialogDefaultV2,
  InputV2,
  InputFormatV2,
  UsuarioSelectV2,
  OptionSelectV2,
  DatePickerV2,
  DropzoneV2,
} from '../../../components/v2';
import { convertTimeToMinutes, isNullOrUndefined, isValidTime, formatToTime } from 'utils';

const defaultSchema = {
  data: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  tipoServico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  cidade: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  inspetor: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  inicioJornada: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  fotoInicioJornada: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const validateInvalidTimes = (values) => {
  let errors = {};

  if (!isNullOrUndefined(values.inicioJornada) && !isValidTime(values.inicioJornada)) {
    errors = { ...errors, inicioJornada: ['Horário inválido'] };
  }
  if (!isNullOrUndefined(values.inicioIntervalo) && !isValidTime(values.inicioIntervalo)) {
    errors = { ...errors, inicioIntervalo: ['Horário inválido'] };
  }
  if (!isNullOrUndefined(values.finalIntervalo) && !isValidTime(values.finalIntervalo)) {
    errors = { ...errors, finalIntervalo: ['Horário inválido'] };
  }
  if (!isNullOrUndefined(values.finalJornada) && !isValidTime(values.finalJornada)) {
    errors = { ...errors, finalJornada: ['Horário inválido'] };
  }

  return errors;
};

const hasError = (values) => {
  let schema = defaultSchema;

  if (
    (values.inicioIntervalo != null && values.fotoInicioIntervalo == null)
    || (values.inicioIntervalo == null && values.fotoInicioIntervalo != null)
  ) {
    schema = {
      ...schema,
      inicioIntervalo: { presence: { allowEmpty: false, message: 'é obrigatório' } },
      fotoInicioIntervalo: { presence: { allowEmpty: false, message: 'é obrigatório' } },
    };
  }

  if (
    (values.finalIntervalo != null && values.fotoFinalIntervalo == null)
    || (values.finalIntervalo == null && values.fotoFinalIntervalo != null)
  ) {
    schema = {
      ...schema,
      finalIntervalo: { presence: { allowEmpty: false, message: 'é obrigatório' } },
      fotoFinalIntervalo: { presence: { allowEmpty: false, message: 'é obrigatório' } },
    };
  }

  if (
    (values.finalJornada != null && values.fotoFinalJornada == null)
    || (values.finalJornada == null && values.fotoFinalJornada != null)
  ) {
    schema = {
      ...schema,
      finalJornada: { presence: { allowEmpty: false, message: 'é obrigatório' } },
      fotoFinalJornada: { presence: { allowEmpty: false, message: 'é obrigatório' } },
    };
  }

  return {
    ...validate(values, schema),
    ...validateInvalidTimes(values),
  };
};

const buildDropzoneFiles = (file, onClear) => (
  file != null
    ? [{
      file,
      nome: file.name,
      onDelete: onClear,
    }]
    : []
);

const Formulario = ({
  open,
  id,
  onClose,
  loadControleFrequencia,
  controleFrequencia,
  saveControleFrequencia,
  authData,
}) => {
  const [readOnly, setReadOnly] = useState(false);
  const [errors, setErrors] = useState({});
  const [values, setValues] = useState({
    data: moment().valueOf(),
    tipoControle: 'CONTROLE_JORNADA',
  });

  useEffect(() => {
    if (id) loadControleFrequencia(id);
  }, [id, loadControleFrequencia]);

  useEffect(() => {
    if (id && controleFrequencia && id === controleFrequencia.id) {
      setValues({
        ...controleFrequencia,
        data: moment(parseInt(controleFrequencia.data, 10)).valueOf(),
      });
      setReadOnly(authData.id !== controleFrequencia.criadoPor);
    } else {
      setValues({ data: moment().valueOf(), tipoControle: 'CONTROLE_JORNADA' });
      setReadOnly(false);
    }
  }, [controleFrequencia, id, authData.id]);

  const onSave = () => {
    const erros = hasError(values);
    if (erros != null && Object.keys(erros).length > 0) {
      setErrors(erros);
      return;
    }
    saveControleFrequencia(values, () => onCloseLocal(true));
  };

  const onCloseLocal = (isSave) => {
    setErrors({});
    setValues({ data: moment().valueOf(), tipoControle: 'CONTROLE_JORNADA' });
    setReadOnly(false);
    onClose(isSave);
  };

  const onChange = (e, field) => {
    const value = e.target.value;

    const inicioJornadaMinutes = convertTimeToMinutes(field === 'inicioJornada' ? value : values.inicioJornada);
    const inicioIntervaloMinutes = convertTimeToMinutes(field === 'inicioIntervalo' ? value : values.inicioIntervalo);
    const finalIntervaloMinutes = convertTimeToMinutes(field === 'finalIntervalo' ? value : values.finalIntervalo);
    const finalJornadaMinutes = convertTimeToMinutes(field === 'finalJornada' ? value : values.finalJornada);

    const first = (inicioJornadaMinutes && inicioIntervaloMinutes && inicioIntervaloMinutes > inicioJornadaMinutes)
      ? inicioIntervaloMinutes - inicioJornadaMinutes
      : null;
    const second = (finalJornadaMinutes && finalIntervaloMinutes && finalJornadaMinutes > finalIntervaloMinutes)
      ? finalJornadaMinutes - finalIntervaloMinutes
      : null;
    const jornadaTotal = first !== null || second !== null ? (first || 0) + (second || 0) : null;

    setValues({
      ...values,
      [field]: value,
      jornadaTotal: jornadaTotal ? formatToTime(jornadaTotal) : null,
    });
  };

  const renderTimeBlock = (timeField, photoField, label) => (
    <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
      <InputFormatV2
        label={label}
        value={values[timeField]}
        onChange={(e) => onChange(e, timeField)}
        format="##:##"
        placeholder="HH:MM"
        disabled={readOnly}
        isRequired={timeField === 'inicioJornada'}
        error={!!(errors && errors[timeField])}
        helperText={errors && errors[timeField] ? errors[timeField] : null}
      />
      <DropzoneV2
        buttonText="Foto"
        filesLimit={1}
        acceptedFiles={['.png', '.pdf', '.jpeg', '.jpg']}
        buttonClassName="buttonContainer"
        error={!!(errors && errors[photoField])}
        onSave={(files) => {
          if (files != null && files.length > 0) {
            setValues({ ...values, [photoField]: files[0] });
          }
        }}
        disabled={readOnly}
        showGridFiles
        files={buildDropzoneFiles(values[photoField], () => setValues({ ...values, [photoField]: null }))}
        canDeleteFiles={!readOnly}
      />
    </Grid>
  );

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSave}
      title="Jornada"
      confirmMessage="Salvar"
      maxWidth="md"
      fullWidth
      readOnly={readOnly}
    >
      <Grid container spacing={1} sx={{ mt: 0 }}>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <DatePickerV2
            label="Data"
            onChange={(data) => setValues({ ...values, data })}
            value={values.data}
            isRequired
            error={!!(errors && errors.data)}
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <OptionSelectV2
            label="Tipo de Serviços"
            codigo="TIPO_SERVICO"
            isRequired
            error={!!(errors && errors.tipoServico)}
            onSelect={(tipoServico) => setValues({ ...values, tipoServico })}
            value={values.tipoServico}
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <InputV2
            error={!!(errors && errors.cidade)}
            isRequired
            label="Cidade"
            name="cidade"
            onChange={(event) => setValues({
              ...values,
              cidade: event.target.value || null,
            })}
            value={values.cidade || ''}
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <UsuarioSelectV2
            label="Inspetor"
            onSelect={(inspetor) => setValues({ ...values, inspetor })}
            isRequired
            error={!!(errors && errors.inspetor)}
            grupos={[Role.ADMIN, Role.INSPETOR]}
            value={values.inspetor}
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <UsuarioSelectV2
            label="Parceiro"
            onSelect={(inspetorAuxiliar) => setValues({ ...values, inspetorAuxiliar })}
            grupos={[Role.ADMIN, Role.INSPETOR]}
            value={values.inspetorAuxiliar}
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <InputV2 label="Hora Total Trabalhada" disabled value={values.jornadaTotal || ''} />
        </Grid>
        {renderTimeBlock('inicioJornada', 'fotoInicioJornada', 'Inicio Jornada')}
        {renderTimeBlock('inicioIntervalo', 'fotoInicioIntervalo', 'Inicio Intervalo')}
        {renderTimeBlock('finalIntervalo', 'fotoFinalIntervalo', 'Final Intervalo')}
        {renderTimeBlock('finalJornada', 'fotoFinalJornada', 'Final Jornada')}
      </Grid>
    </DialogDefaultV2>
  );
};

Formulario.propTypes = {
  open: PropTypes.bool.isRequired,
  id: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  loadControleFrequencia: PropTypes.func.isRequired,
  controleFrequencia: PropTypes.object,
  saveControleFrequencia: PropTypes.func.isRequired,
  authData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  controleFrequencia: selectorsControleFrequencias.getSelectedControleFrequencia(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...actionsControleFrequencias,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Formulario));
